import { CaretUpFilled as AntDCaretUpFilled } from "@ant-design/icons"
import styled from "styled-components"

const CaretUpFilled = styled(AntDCaretUpFilled)`
  color: ${props => props.theme.color.iconColor.greenColor1};
`

export { CaretUpFilled }
